import { Box } from '@mui/material'

import useObject from '../useObject'

import PropertyDetail from './PropertyDetail'
import { SidebarMode } from './SidebarContext'
import SidebarModeConsole from './SidebarModeConsole'
import SidebarModeCreate from './SidebarModeCreate'
import SidebarModeEdit from './SidebarModeEdit'
import SidebarModeRelated from './SidebarModeRelated'
import SidebarModeThreads from './SidebarModeThreads'
import SidebarModeTimeline from './SidebarModeTimeline'
import SidebarModeView from './SidebarModeView'
import useSidebar from './useSidebar'

const SidebarContent = () => {
  const { object } = useObject()
  const { mode } = useSidebar()

  return (
    object && (
      <Box className="sidebar-content">
        {mode === SidebarMode.CREATE ? (
          <SidebarModeCreate />
        ) : mode === SidebarMode.EDIT ? (
          <SidebarModeEdit />
        ) : mode === SidebarMode.PROPERTY ? (
          <PropertyDetail />
        ) : mode === SidebarMode.VIEW ? (
          <SidebarModeView />
        ) : mode === SidebarMode.CONSOLE ? (
          <SidebarModeConsole />
        ) : null}
        {mode === SidebarMode.THREADS ? <SidebarModeThreads /> : null}
        {mode === SidebarMode.TIMELINE ? <SidebarModeTimeline /> : null}
        {mode === SidebarMode.RELATED ? <SidebarModeRelated /> : null}
      </Box>
    )
  )
}

export default SidebarContent
